import React from 'react';
import { Box, Grid, Modal } from '@mui/material';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import ReactPlayer from 'react-player';

function VideoModal(props) {
  const { open, videoUrl, handleClose } = props;
  return (
    <Modal open={open} onClose={handleClose}>
      <Box className="modal-common video-modal">
        <Grid container>
          <Grid
            item
            xs={12}
            sm={12}
            md={12}
            lg={12}
            className="align-right"
            onClick={handleClose}
          >
            <CloseRoundedIcon />
          </Grid>

          <Grid item xs={12} sm={12} md={12} lg={12}>
            <ReactPlayer url={videoUrl} controls={true} width="100%" />
          </Grid>
        </Grid>
      </Box>
    </Modal>
  );
}
export default VideoModal;
